import { Card, Row, Col, Statistic } from "antd";

export default function UserStatsCard({
  titleMap,       // { total: "Total", col1: "Paid", col2: "Unpaid", percentage: "Percentage of paid users / total users" }
  stats,          // { total: number, col1: number, col2: number }
  initialLoading,
  chartComponent  // <UserPaymentChart ... /> hoặc <UserUsageChart ... />
}) {
  return (
    <Card style={{ marginBottom: 18 }}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="space-between" style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title={titleMap.total}
              loading={initialLoading}
              value={stats.total}
              valueStyle={{ color: "#4a90e2", fontWeight: "bold" }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title={titleMap.col1}
              loading={initialLoading}
              value={stats.col1}
              valueStyle={{ color: "#333", fontWeight: "bold" }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title={titleMap.col2}
              loading={initialLoading}
              value={stats.col2}
              valueStyle={{ color: "#333", fontWeight: "bold" }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title={titleMap.percentage}
              loading={initialLoading}
              value={stats.total ? ((stats.col1 * 100) / stats.total).toFixed(2) : 0}
              valueStyle={{ color: "#333", fontWeight: "bold" }}
              suffix="%"
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="space-between">
        {chartComponent}
      </Row>
    </Card>
  );
}
